import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
// import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // obtener el token del localStorage
    const token = localStorage.getItem('token');

    // ============================================================
    // Backend URL Switch — DESHABILITADO tras migración a fargate.
    // Fecha desactivación: 09/09/2026
    // Referencia: .kiro/specs/backend-url-switch
    // Si en el futuro se requiere volver a alternar URLs de backend
    // vía sessionStorage, descomentar este bloque y restaurar el
    // import de `environment` arriba.
    // ------------------------------------------------------------
    // let url = req.url;
    //
    // const urlOverride = sessionStorage.getItem('API_BASE_URL_OVERRIDE');
    // if (urlOverride && url.startsWith(environment.URL_SERVICIOS)) {
    //   url = url.replace(environment.URL_SERVICIOS, urlOverride);
    // }
    // ============================================================

    // si tenemos token agregamos token y secret
    if (token) {
      const headers = req.headers
        .set('Authentication', `Bearer ${token}`);

      // clonamos la solicitud para incluir los headers
      const authReq = req.clone({ headers });

      // pasar la solicitud clonada con los headers al siguiente interceptor o servicio
      return next.handle(authReq);
    }

    // Bloque de fallback del Backend URL Switch — DESHABILITADO. 09/09/2026
    // if (urlOverride && url !== req.url) {
    //   return next.handle(req.clone({ url }));
    // }

    // si por alguna razon no entra a los if se va sin headers
    return next.handle(req);
  }
}
